import { interpolateTranslationVars } from '@/utils/i18n/interpolateTranslationVars';
import type { HubUiTranslationBundle } from '@/utils/i18n/types';
import type { LanguageCode } from '@/utils/languages/supportedLanguages';

export function resolveTranslation(
  key: string,
  fallback: string,
  bundle: HubUiTranslationBundle,
  enabled: boolean,
  locale: LanguageCode,
  vars?: Record<string, string | number>
): string {
  if (!enabled || locale === 'en') {
    return interpolateTranslationVars(fallback, vars);
  }

  const value = bundle[key];
  if (value == null || value === '') {
    return interpolateTranslationVars(fallback, vars);
  }

  return interpolateTranslationVars(value, vars);
}
